var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysicalActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DEF3FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#FFA998"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8283 12.0596C23.2314 12.0348 21.685 12.6234 20.5033 13.7059C19.3189 12.6236 17.7706 12.0351 16.1719 12.0596C12.84 12.0596 9.91187 14.8421 9.91187 18.012C9.944 19.1507 10.1919 20.2726 10.6423 21.3175H10.7576C11.8725 21.3175 13.1732 21.3175 14.4355 21.3175H16.8767C16.96 21.3175 16.9728 21.3175 17.0113 21.1948C17.3701 19.9639 17.7332 18.7329 18.1005 17.502L18.2415 17.0242C18.2776 16.83 18.3763 16.6533 18.5223 16.5214C18.6682 16.3895 18.8533 16.3098 19.0488 16.2947C19.2669 16.281 19.4822 16.3504 19.6519 16.4892C19.8216 16.6279 19.9334 16.8258 19.9651 17.0436L21.3106 21.8404L21.8489 20.3168C21.8949 20.1178 22.0084 19.9412 22.1698 19.8174C22.3312 19.6937 22.5304 19.6306 22.7331 19.6389H24.8219C24.9481 19.6405 25.0727 19.6676 25.1884 19.7183C25.3041 19.7691 25.4086 19.8427 25.4957 19.9347C25.5828 20.0267 25.6508 20.1353 25.6958 20.2541C25.7407 20.3729 25.7617 20.4996 25.7574 20.6267C25.7614 20.8976 25.6602 21.1593 25.4755 21.3562C25.3047 21.5267 25.0751 21.6239 24.8347 21.6273H23.4123C23.3226 21.6273 23.3097 21.6273 23.2713 21.7435C22.9766 22.6022 22.6818 23.4544 22.3807 24.3259L22.1308 25.0555C21.9065 25.7011 21.5413 25.8302 21.2594 25.8302H21.2273C20.8109 25.8302 20.5225 25.5397 20.3687 25.0038L19.0873 20.5427L18.517 22.5118C18.3504 23.0928 18.0749 23.3188 17.5367 23.3188H11.6483C12.2293 24.2754 12.8986 25.1746 13.6474 26.0045C15.9156 28.5029 18.5362 30.0588 20.5033 30.0588C22.4704 30.0588 25.091 28.5029 27.3528 26.0045C29.6146 23.506 31.0883 20.4524 31.0883 18.0185C31.0883 14.8486 28.1602 12.0596 24.8283 12.0596Z",
    fill: "#121622"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalActivity);
export default __webpack_public_path__ + "static/media/physical-activity.c48ce52c3f73eb9c6d3e2de7431523d3.svg";
export { ForwardRef as ReactComponent };